export default {
  name: 'RadioGroup',
  provide() {
    const radioProvided = {};

    Object.defineProperty(radioProvided, 'disable', {
      enumerable: true,
      get: () => this.disable,
    });

    Object.defineProperty(radioProvided, 'value', {
      enumerable: true,
      get: () => this.value,
    });

    radioProvided.emitInput = this.emitInput;
    return {
      radioProvided,
    };
  },
  props: {
    disable: Boolean,
    value: {
      default: '',
      type: [String, Object, Number, Array],
    },
    position: {
      type: String,
      default: 'vertical',
      validator: (value) => {
        return ['vertical', 'horizontal'].indexOf(value) !== -1;
      },
    },
  },
  methods: {
    emitInput(val) {
      this.$emit('input', val);
    },
  },
};
